import React, { Suspense, lazy } from 'react';
import cx from 'classnames';
import { useResizeDetector } from 'react-resize-detector';
import { useTheme } from '../../config/ThemeContext';

const AppMain = lazy(() => import('../../Layout/AppMain'));

const Main: React.FC = () => {
  const {
    state: {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    },
  } = useTheme();
  const { width, ref } = useResizeDetector();

  return (
    <div ref={ref}>
      <div
        className={cx(
          `app-container app-theme-${colorScheme}`,
          { 'fixed-header': enableFixedHeader },
          {
            'fixed-sidebar': enableFixedSidebar || (width && width < 1250),
          },
          { 'fixed-footer': enableFixedFooter },
          {
            'closed-sidebar': enableClosedSidebar || (width && width < 1250),
          },
          {
            'closed-sidebar-mobile':
              closedSmallerSidebar || (width && width < 1250),
          },
          { 'sidebar-mobile-open': enableMobileMenu },
          { 'body-tabs-shadow-btn': enablePageTabsAlt },
        )}
      >
        <Suspense fallback={null}>
          <AppMain />
        </Suspense>
      </div>
    </div>
  );
};

export default Main;
